module.exports = __webpack_public_path__ + "static/mg-49b54e63cda00fa79f839c7083bbef7a.png";